export default __webpack_public_path__ + "static/media/city-centers.874c9700.svg";